import { compose } from 'recompose';

import DebitCardForm from './DebitCardForm';
import AddCardContainer from './AddCardContainer';
import EditCardContainer from './EditCardContainer';
import DebitCardFormContainer from './DebitCardFormContainer';

export const PureDebitCardForm = DebitCardFormContainer(DebitCardForm);
export const AddDebitCardForm = compose(AddCardContainer, DebitCardFormContainer)(DebitCardForm);
export const EditDebitCardForm = compose(EditCardContainer, DebitCardFormContainer)(DebitCardForm);
